import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeConversationStart } from "redux/chats/chats.actions";
import useMediaQuery from "use-mediaquery";
import routes from "routes";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

function CloseConvModal({
  setCloseConvModalInfo,
  closeConvModalInfo,
  CONV_MODAL_INITIAL_STATE,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSmallDevice = useMediaQuery("(max-width: 650px)");
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const selectedConversation = useSelector(getSelectedConversation);

  const onSuccessfullyCloseConv = () => {
    if (isSmallDevice) {
      navigate(routes.convsList);
    } else {
      navigate(routes.home);
    }

    setCloseConvModalInfo(CONV_MODAL_INITIAL_STATE);
  };

  const closeConversation = () => {
    dispatch(
      closeConversationStart({
        action: closeConvModalInfo.status,
        userId: selectedConversation.user.id,
        convId: selectedConversation.conversation.id,
        onSuccess: onSuccessfullyCloseConv,
      })
    );

    if (isSmallDevice) navigate(routes.convsList);
    setCloseConvModalInfo(CONV_MODAL_INITIAL_STATE);
  };

  const handleCloseConvModalDisplay = (status) => {
    setCloseConvModalInfo({
      show: status,
      status: null,
    });
  };

  return (
    <Modal
      visible={closeConvModalInfo.show}
      setVisibility={handleCloseConvModalDisplay}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {closeConvModalInfo.status === "close"
              ? t("MODAL").CLOSE_CONV_CONFIRM
              : t("MODAL").REJECT_CONV_CONFIRM}
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={() =>
              setCloseConvModalInfo({
                show: false,
                status: null,
              })
            }
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("CANCEL")}
          </button>
          <button
            onClick={() => closeConversation()}
            className="btn btn-primary"
          >
            {t("CONFIRM")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default CloseConvModal;
